import { FormCheck } from 'react-bootstrap';
import { Plus } from 'lucide-react';
import { Button as ButtonTW } from '../../../../ui/button';
import PercentageInput from '../../../../common/PercentageInput';

const StrategyActions = ({
  assetLiabilityEditable,
  cashflowEditable,
  reinvestmentsEditable,
  onAddAssetClick,
  onAddLiabilityClick,
  onAddCashflowClick,
  onAddReinvestmentOption,
  disabled,
  translate,
  inflationApplied,
  onInflationApplyCheckedChange,
  inflationValue,
  onInflationValueChange,
  stressTestApplied,
  setStressTestApplied,
  showStressTestAndArmaggedonToClient,
  readOnlyMode
}) => {
  const actionsConfig = [
    {
      condition: assetLiabilityEditable,
      onClick: onAddAssetClick,
      text: translate('assets')
    },
    {
      condition: assetLiabilityEditable,
      onClick: onAddLiabilityClick,
      text: translate('liabilities')
    },
    {
      condition: cashflowEditable,
      onClick: onAddCashflowClick,
      text: translate('cashflow')
    },
    {
      condition: reinvestmentsEditable,
      onClick: onAddReinvestmentOption,
      text: translate('reinvestments')
    }
  ].filter(a => Boolean(a.condition));

  return (
    <div>
      <div className="flex items-center gap-3 mb-1">
        {actionsConfig.map((action, index) => (
          <ButtonTW
            key={index}
            variant="outline"
            size="sm"
            disabled={disabled}
            onClick={action.onClick}
            className="inline-flex items-center justify-center gap-1 rounded-full border-secondary-dark text-secondary-dark shadow-none text-xs hover:bg-[rgb(var(--bs-secondary-dark-rgb),0.1)] hover:text-secondary-dark m-0"
          >
            <Plus className="w-3 h-3" />
            <span className="text-sm">{action.text}</span>
          </ButtonTW>
        ))}
        {showStressTestAndArmaggedonToClient && (
          <FormCheck
            style={{ minHeight: '0px' }}
            onChange={e => setStressTestApplied(e.target.checked)}
            checked={stressTestApplied}
            disabled={readOnlyMode}
            label={<span className="text-secondary-dark text-sm">{translate('apply_stress_test')}</span>}
          />
        )}
        <FormCheck
          style={{ minHeight: '0px' }}
          checked={inflationApplied}
          onChange={onInflationApplyCheckedChange}
          label={
            <span className="text-secondary-dark text-sm">
              {translate('adjust_to_inflation')}
              {inflationApplied ? ':' : ''}
            </span>
          }
        />
        {inflationApplied && (
          <PercentageInput
            style={{ width: 50, minHeight: '0px' }}
            className="mx-1 p-0 px-1 border-0 bg-primary-light"
            size="sm"
            value={inflationValue}
            onChange={onInflationValueChange}
            autoFocus
          />
        )}
      </div>
    </div>
  );
};

export default StrategyActions;
